import { stripVTControlCharacters } from 'node:util';

/** Make untrusted text safe for human-readable terminal output. */
export function sanitizeTerminalText(value: string): string {
  const normalizedNewlines = value.replace(/\r\n?/g, '\n');
  return stripVTControlCharacters(normalizedNewlines).replace(
    /[\u0000-\u0009\u000b-\u001f\u007f-\u009f]/g,
    '',
  );
}

/** One argument as a message quotes it: sanitized, and an empty one shown as `""`. */
export function shownArgument(value: string): string {
  return value === '' ? '""' : sanitizeTerminalText(value);
}
